const styles = {
  panoContainer: {
    position: "relative",
    width: "100%",
    // 175 because the bottom thumbnail scroll is 137 in height and the close button is 38 in height //
    height: (props: any) => (props.fullScreen ? "auto" : "calc(100% - 175px)"),
    overflow: "hidden",
    display: "inline-block",
    "@media screen and (max-width : 1200px)": {
      height: "calc(100% - 56px)",
    },
  },
};

export default styles;
